var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "466px",
    height: "313px",
    viewBox: "0 0 466 313",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing-page-02-desktop",
    transform: "translate(-652.000000, -230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sections"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section--intro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud",
    transform: "translate(652.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.055684,312.328467 L127.409211,312.328467 C57.0430466,312.328467 -3.55271368e-14,255.285256 -3.55271368e-14,184.919092 C-3.55271368e-14,114.552928 57.0430466,57.5098816 127.409211,57.5098816 C129.679145,57.5098816 131.963724,57.5098816 134.233658,57.6856184 C160.960303,21.3227368 202.258461,2.48689958e-14 247.232447,2.48689958e-14 C283.525228,0.00765408197 318.378352,14.1969535 344.356342,39.5407895 C365.895301,60.4188056 380.509429,87.4030604 386.225645,116.850355 C436.103356,126.634281 470.385631,172.710548 465.424848,223.296139 C460.464064,273.881729 417.883854,312.420313 367.055684,312.328467 L367.055684,312.328467 Z M127.409211,101.444092 C81.3072417,101.444093 43.9342123,138.817123 43.9342123,184.919092 C43.9342123,231.021061 81.3072417,268.394092 127.409211,268.394092 L367.055684,268.394092 C396.927755,267.905386 420.887848,243.550101 420.887848,213.674033 C420.887848,183.797965 396.927755,159.442679 367.055684,158.953974 L346.230868,158.953974 L344.839618,138.451342 C341.207724,85.42275 298.342579,43.8902763 247.232447,43.8902763 C213.124855,43.8902763 182.019434,61.9325921 164.006408,92.2179079 L156.303276,105.105276 L141.468158,102.615671 C136.822437,101.83597 132.119906,101.444092 127.409211,101.444092 L127.409211,101.444092 Z",
    id: "outer",
    fill: "#577138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.468158,102.615671 C136.822437,101.83597 132.119906,101.444092 127.409211,101.444092 C81.307242,101.444093 43.934213,138.817124 43.934213,184.919092 C43.934213,231.021061 81.307242,268.394092 127.409211,268.394092 L367.055684,268.394092 C396.927755,267.905386 420.887848,243.550101 420.887848,213.674033 C420.887848,183.797965 396.927755,159.442679 367.055684,158.953974 L346.230868,158.953974 L344.839618,138.451342 C341.207724,85.42275 298.342579,43.8902763 247.232447,43.8902763 C213.124855,43.8902763 182.019434,61.9325921 164.006408,92.2179079 L156.303276,105.105276 L141.468158,102.615671 Z",
    id: "inner",
    fill: "#DDE072"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "core",
    fill: "#5E3108",
    cx: 247.832882,
    cy: 141.512092,
    r: 58.5789474
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4ca0f3f6f818d70abf315bbee944770f.svg";
export { ForwardRef as ReactComponent };